import React from 'react';
import './AccountBlockedComponent.less';
import {ButtonPrimary} from '@homeaway/react-buttons';

function AccountBlockedComponent({lingua}) {
    return (
        <div className="AccountBlocked text-center">
            <p className="content">{lingua.read('lex.owner.blocked')}</p>
            <ButtonPrimary className="btn-lg" label={lingua.read('lex.button.contact')} href={lingua.read('lex.help.link')}/>
        </div>
    );
}

export default AccountBlockedComponent;
